import { user } from "../types"

const INITIAL_STATE = {
    error: undefined,
    wallet_applicable: false,
    gstValidationMessage: "",
}


 const userreducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case user.USER_PROFILE_SUCCESS:
            return {
                ...state,
                user: action.payload
            }
        case user.GET_CITY_FROM_PINCODE_SUCCESS:
                return {
                    ...state,
                    pinCity: action.payload
                }    
        case user.CITIES_LIST_SUCCESS:
                return {
                        ...state,
                        cities: action.payload
                }        
        case user.RESET_USERS_STORE_SUCCESS:
             return INITIAL_STATE   

        case user.USER_WALLRT_APPLICABLE:
            return {
                ...state,
                wallet_applicable: action.payload
            }
        case user.GST_VALIDATION_SUCCESS:
            return {
                ...state,
                gstValidationMessage: action.payload
            }    

        case user.USER_PROFILE_FAILURE:
            return {
                ...state,
                error: action.payload
            }

        default :
            return state    
        }
}

export default userreducer